import * as state from './state.js';
let getters = {
    getUserId: state => {
        return state.id;
    },
    getOpenId: state => {
        return state.openId;
    },
    getToken: state => {
        return state.token;
    },
    getUserName: state => {
        return state.name;
    },
    getNickName: state => {
        return state.nickName;
    },
    getAvatar: state => {
        return state.avatar;
    },
    getEmail: state => {
        return state.email;
    },
    getSex: state => {
        return state.sex;
    },
    getCity: state => {
        return state.city;
    },
    getProvince: state => {
        return state.province;
    },
    getCountry: state => {
        return state.country;
    },
    getWxConf: state => {
        return state.wxConf;
    }
};
export default getters;


// WEBPACK FOOTER //
// ./src/vuex/modules/wxAuth/getters.js